import {
    despatchProfileTypesSelectData, despatchTypesSelectData,
    invoiceProfileTypesSelectData,
    invoiceTypesSelectData
} from "../../../helper/helper";

export function getSearchFields(docType){
    if(["invoice","archiveInvoice"].includes(docType)){
        return [
            {
                label: "Fatura No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Fatura ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Fatura Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Fatura Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "Senaryo Türü",
                accessor: "documentProfile",
                type: "select",
                operator: "=",
                selectData: invoiceProfileTypesSelectData()
            },
            {
                label: "Fatura Türü",
                accessor: "invoiceTypeCode",
                type: "select",
                operator: "=",
                selectData: invoiceTypesSelectData()
            }
        ]
    }
    else if(docType === "despatch"){
        return [
            {
                label: "İrsaliye No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "İrsaliye ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "İrsaliye Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "İrsaliye Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "Senaryo Türü",
                accessor: "despatchTypeCode",
                type: "select",
                operator: "=",
                selectData: despatchProfileTypesSelectData()
            },
            {
                label: "İrsaliye Türü",
                accessor: "documentProfile",
                type: "select",
                operator: "=",
                selectData: despatchTypesSelectData()
            }
        ];
    }
    else if(["mm", "smm"].includes(docType)){
        return [
            {
                label: "Makbuz No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Makbuz ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Makbuz Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
            },
            {
                label: "Makbuz Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            },
            {
                label: "İptal Durumu",
                accessor: "cancelled",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "0", label: "İptal Edilmeyenler"},
                    {value: "1", label: "İptal Edilenler"},
                ]
            }

        ]
    }
    else if(["edefter-bildirim"].includes(docType)){
        return [
            {
                label: "Yıl",
                accessor: "year",
                type: "numericText",
                operator: "="
            },
            {
                label: "Ay",
                accessor: "month",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "1", label: 'Ocak'},
                    {value: "2", label: 'Şubat'},
                    {value: "3", label: 'Mart'},
                    {value: "4", label: 'Nisan'},
                    {value: "5", label: 'Mayıs'},
                    {value: "6", label: 'Haziran'},
                    {value: "7", label: 'Temmuz'},
                    {value: "8", label: 'Ağustos'},
                    {value: "9", label: 'Eylül'},
                    {value: "10", label: 'Ekim'},
                    {value: "11", label: 'Kasım'},
                    {value: "12", label: 'Aralık'}
                ]
            },
            {
                label: "VKN/TCKN",
                accessor: "customer_vknTckn",
                type: "numericText",
                operator: "=",
            }
        ];
    }
    else if(["edefter"].includes(docType)){
        return [
            {
                label: "Dönem",
                accessor: "min_startDate",
                type: "month",
                operator: ">=",
            },
            {
                label: "VKN/TCKN",
                accessor: "customer_vknTckn",
                type: "numericText",
                operator: "=",
            }
        ];
    }
    else if(docType === "sgkInvoice"){
        return [
            {
                label: "VKN/TCKN",
                accessor: "vknTckn",
                type: "text",
                operator: "="
            },
            {
                label: "GLN",
                accessor: "userList_username",
                type: "text",
                operator: "="
            },
            {
                label: "Unvan",
                accessor: "formattedName",
                type: "text",
                operator: "="
            },
            {
                label: "Ad",
                accessor: "givenName",
                type: "text",
                operator: "="
            },
            {
                label: "Soyad",
                accessor: "familyName",
                type: "text",
                operator: "="
            }
        ]
    }
    else if(docType === "eExpenseNote"){
        return [
            {
                label: "Pusula No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Pusula ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationId",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Pusula Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "Pusula Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
            }
        ]
    }
}